import React, { useEffect, useState } from 'react'
import CryptoJS from 'crypto-js'
import { ApiType, EncKeys, MicroservicesBaseUrl } from '../../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    calculateTransactionCharges,
    createPaymentRequestData,
} from '../../redux/actions/ComponentCallsActions'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import {
    Card,
    Grid,
    InputAdornment,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Box,
} from '@mui/material'
import { PersonPin } from '@mui/icons-material'
import { alertService } from '../../services/alert-service'
import axios from 'axios'
import { formatCurrency } from 'globalize'

const JioPayCard = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()

    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    const paymentData = useSelector((state) => state.customerData)
    const [cardYears, setcardYears] = useState([])
    const [charges, setCharges] = useState()

    const [axisState, setAxisState] = useState({
        cvv: '',
        cardHolder: '',
        cardNumber: '',
        month: '',
        year: '',
    })

    const handleMonthChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.month = value
        setAxisState(temp)
    }

    const handleYearChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.year = value
        setAxisState(temp)
    }

    const handleChange = ({ target: { name, value } }) => {
        if (name === 'cardHolder') {
            const alphaValue = value.replace(/[^a-zA-Z\s]/g, '')
            let temp = { ...axisState }
            temp.cardHolder = alphaValue
            setAxisState(temp)
        } else if (name === 'cvv') {
            const number = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cvv = number
            setAxisState(temp)
        } else if (name === 'cardNumber') {
            const filteredValue = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cardNumber = filteredValue
            setAxisState(temp)
        } else {
            let temp = { ...axisState }
            temp[name] = value
            setAxisState(temp)
        }
    }

    const getCardYear = () => {
        let years = []
        for (let i = 0; i < 10; i++) {
            let value = new Date().getFullYear() + i
            let text = new Date().getFullYear() + i + ''
            years.push({ value: value, text: text })
        }

        let tempYear = [...years]
        setcardYears(tempYear)
    }

    const SubmitRequest = () => {
        if (axisState.cardHolder === '') {
            alertService.addError('Card Holder name is required')
            return false
        }
        if (axisState.cardNumber === '') {
            alertService.addError('Card Number is required')
            return false
        }
        if (axisState.cardNumber.length !== 16) {
            alertService.addError(`Card Number must be of 16 digits`)
            return false
        }
        if (axisState.month === '' || axisState.month === undefined) {
            alertService.addError('Month is required')
            return false
        }
        if (axisState.year === '' || axisState.year === undefined) {
            alertService.addError('Year is required')
            return false
        }
        if (axisState.cvv === '') {
            alertService.addError('Cvv Number is required')
            return false
        } else if (axisState.cvv.length !== 3) {
            alertService.addError('Cvv Number must be of 3 digits')
            return false
        }

        const CardNumber = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(axisState.cardNumber.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        const Cvv = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(axisState.cvv.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        const ExpMonth = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(axisState.month.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        const ExpYear = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(axisState.year.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'JioPayCard',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            Cvv: Cvv.toString(),
            ExpiryMonth: ExpMonth.toString(),
            ExpiryYear: ExpYear.toString(),
            CardHolderName: axisState.cardHolder,
            CardNo: CardNumber.toString(),
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
            Email: '',
            Contact: '',
            TokenId: '',
            IsCardDetailSaved: false,
            IsNewCardDetailSave: false,
        }

        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'JioPayCard')

                        let actualResponse = JSON.parse(decrypted)
                        window.location.replace(actualResponse)
                    } else if (res.errorMessage === 'BIN is not enabled.') {
                        alertService.addError(res.errorMessage)
                    } else {
                        alertService.addError(res?.errorMessage)
                        // const transactionResponse = {
                        //     Comments: res.errorMessage,
                        //     Status: 'Transaction declined',
                        //     TransactionId: '',
                        //     TrackId: '',
                        //     Amount: '',
                        //     TransactionDate: '',
                        //     RedirectUrl:
                        //         paymentData.customerData.PaymentRequest
                        //             .RedirectUrl,
                        // }
                        // history.push({
                        //     pathname: '/TransactionStatus',
                        //     state: transactionResponse,
                        // })
                    }
                },
                (err) => {
                    const msg =
                        err?.response?.data?.errorMessage ||
                        err?.response?.data?.message ||
                        err?.message ||
                        'Request failed'

                    alertService.addError(msg)
                    // const transactionResponse = {
                    //     Comments:
                    //         'Please Contact Vayana Team for further details',
                    //     Status: 'Transaction declined',
                    //     TransactionId: '',
                    //     TrackId: '',
                    //     Amount: '',
                    //     TransactionDate: '',
                    //     RedirectUrl:
                    //         paymentData.customerData.PaymentRequest.RedirectUrl,
                    // }
                    // history.push({
                    //     pathname: '/TransactionStatus',
                    //     state: transactionResponse,
                    // })
                }
            )
        )
    }

    const handleBack = () => {
        props.onBackBtnClick()
    }

    async function getCalculationData() {
        const postRequest = {
            PaymentOption: 'JioPayCard',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            CardNumber: axisState.cardNumber.toString(),
        }

        const jsonBody = JSON.stringify(postRequest)

        const encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody),
            key,
            {
                keySize: 128 / 8,
                iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        const postData = { payload: encryptedPostRequest.toString() }

        try {
            const url = `${MicroservicesBaseUrl.baseApiUrl}api/banking/CalculateTransactionCharges`

            // console.log('calling URL:', url)

            const { data: result } = await axios.post(url, postData)

            // console.log('charges raw result', result)

            if (result.statusCode === 200 && result.data) {
                const decryptedResponse = CryptoJS.AES.decrypt(
                    result.data,
                    key,
                    {
                        keySize: 128 / 8,
                        iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7,
                    }
                )

                const decrypted = decryptedResponse.toString(CryptoJS.enc.Utf8)
                const actualResponse = JSON.parse(decrypted)

                //   console.log('charges decrypted', actualResponse)
                props.setCharges(actualResponse)
                // set local state here if needed
            } else {
                //   console.log('charges non-200', result)
            }
        } catch (err) {
            // console.log('charges error', err)
        }
    }

    useEffect(() => {
        getCardYear()
    }, [])

    return (
        <div>
            <Card sx={{ p: 1, boxShadow: 'none' }}>
                <ValidatorForm onSubmit={SubmitRequest}>
                    <Grid
                        container
                        style={{
                            marginLeft: '2px',
                        }}
                    >
                        <Grid item xs={12}>
                            <Typography
                                style={{
                                    padding: '10px 0px',
                                    marginBottom: '20px',
                                }}
                            >
                                Enter Your Card Details
                            </Typography>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                                <TextValidator
                                    size="small"
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                        marginBottom: '22px',
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <PersonPin />
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={axisState.cardHolder || ''}
                                    onChange={handleChange}
                                    name="cardHolder"
                                    id="outlined-basic"
                                    label="Card Holder"
                                    variant="outlined"
                                    FormHelperTextProps={{
                                        color: 'red',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextValidator
                                    size="small"
                                    sx={{
                                        width: '100%',
                                        marginTop: '10px',
                                        marginBottom: '22px',
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <img
                                                    style={{
                                                        width: '60px',
                                                    }}
                                                    src="https://www.seekpng.com/png/detail/136-1366945_mastercard-logo-png-logo-visa-mastercard-png.png"
                                                    alt="VM"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={handleChange}
                                    value={axisState.cardNumber || ''}
                                    id="outlined-basic"
                                    label="Card Number"
                                    onInput={(e) => {
                                        e.target.value = e.target.value
                                            .toString()
                                            .slice(0, 16)
                                    }}
                                    variant="outlined"
                                    name="cardNumber"
                                    FormHelperTextProps={{
                                        color: 'red',
                                    }}
                                    onPaste={(e) => e.preventDefault()}
                                    onCopy={(e) => e.preventDefault()}
                                    onBlur={getCalculationData}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    className="mb-4"
                                >
                                    <InputLabel
                                        style={{
                                            marginTop: '-5px',
                                        }}
                                        id="cardMonthLabel"
                                    >
                                        MM
                                    </InputLabel>
                                    <Select
                                        size="small"
                                        labelId="cardMonthLabel"
                                        id="cardMonth"
                                        label="Month"
                                        value={axisState.month || ''}
                                        validators={['required']}
                                        onChange={handleMonthChange}
                                    >
                                        <MenuItem value="">
                                            <em>Select Month</em>
                                        </MenuItem>
                                        <MenuItem value="1">
                                            January - (01)
                                        </MenuItem>
                                        <MenuItem value="2">
                                            February - (02)
                                        </MenuItem>
                                        <MenuItem value="3">
                                            March - (03)
                                        </MenuItem>
                                        <MenuItem value="4">
                                            April - (04)
                                        </MenuItem>
                                        <MenuItem value="5">
                                            May - (05)
                                        </MenuItem>
                                        <MenuItem value="6">
                                            June - (06)
                                        </MenuItem>
                                        <MenuItem value="7">
                                            July - (07)
                                        </MenuItem>
                                        <MenuItem value="8">
                                            August - (08)
                                        </MenuItem>
                                        <MenuItem value="9">
                                            September - (09)
                                        </MenuItem>
                                        <MenuItem value="10">
                                            October - (10)
                                        </MenuItem>
                                        <MenuItem value="11">
                                            November - (11)
                                        </MenuItem>
                                        <MenuItem value="12">
                                            December - (12)
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    className="mb-4"
                                >
                                    <InputLabel
                                        style={{
                                            marginTop: '-5px',
                                        }}
                                        id="cardYearLabel"
                                    >
                                        YY
                                    </InputLabel>
                                    <Select
                                        size="small"
                                        labelId="cardYearLabel"
                                        id="cardYear"
                                        label="Year"
                                        value={axisState.year || ''}
                                        onChange={handleYearChange}
                                    >
                                        {cardYears.map((year) => (
                                            <MenuItem
                                                key={year.value}
                                                value={year.value}
                                            >
                                                {year.text}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextValidator
                                    size="small"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '10px',
                                    }}
                                    onChange={handleChange}
                                    name="cvv"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <img
                                                    style={{
                                                        width: '50px',
                                                    }}
                                                    src="https://cdn1.iconfinder.com/data/icons/finance-technology-fintech-vol-3/256/cvv-512.png"
                                                    alt="CVV"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={axisState.cvv || ''}
                                    id="outlined-basic"
                                    label="CVV"
                                    variant="outlined"
                                    type="password"
                                    FormHelperTextProps={{
                                        color: 'red',
                                    }}
                                    maxLength="3"
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} marginTop="10px">
                            <Grid item xs={12} md={6}>
                                <button
                                    type="button"
                                    className="backButton"
                                    style={{
                                        width: '100%',
                                        margin: '10px 0px',
                                    }}
                                    onClick={handleBack}
                                >
                                    Back
                                </button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {props.acceptCharges === false ? (
                                    <button
                                        disabled={
                                            props.acceptCharges === false
                                                ? true
                                                : false
                                        }
                                        className="btn"
                                        style={{
                                            backgroundColor:
                                                paymentData.customerData
                                                    .UIConfig
                                                    .ButtonBackgroundColor,
                                            color: paymentData.customerData
                                                .UIConfig.ButtonTextColor,
                                            opacity: '0.5',
                                        }}
                                    >
                                        Pay
                                    </button>
                                ) : (
                                    <button
                                        className="btn"
                                        style={{
                                            backgroundColor:
                                                paymentData.customerData
                                                    .UIConfig
                                                    .ButtonBackgroundColor,
                                            color: paymentData.customerData
                                                .UIConfig.ButtonTextColor,
                                        }}
                                    >
                                        Pay
                                    </button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </Card>
        </div>
    )
}

export default JioPayCard
